<template>
	<el-dialog title="修改邮箱" :visible.sync="dialogVisible" width="500px" 
		:close-on-click-modal="false">
		<Email ref="email" :params="params" v-if="dialogVisible" />
		<span slot="footer" class="dialog-footer">
			<el-button @click="dialogVisible = false">取 消</el-button>
			<el-button type="primary" @click="submitHandler">确 定</el-button>
		</span>
	</el-dialog>
</template>

<script>
import Email from "@/components/MFA/components/Email.vue";
import { mapGetters } from 'vuex';

export default {
	components: {
		Email,
	},
	data() {
		return {
			dialogVisible: false,
			params: {},
			MFAs: [],
		};
	},
	computed: {
		...mapGetters([
			'userInfo'
		])
	},
	methods: {
		open(params) {
			this.params = params;
			console.log(params);
			this.dialogVisible = true;
		},
		submitHandler() {
			let data = this.$refs.email.getCode();
			this.$api
				.commonUpdateSecverifyContact({
					bit: data.bit,
					key: data.key,
					email: data.email,
					code: data.code,
				})
				.then((response) => {
					if (response.errcode != 0) return;
					if (!this.userInfo.email) {
						this.$message.success("绑定成功!");
					} else {
						this.$message.success("修改成功!");
					}
					this.$store.dispatch("user/getInfo").then((response) => {
					});
					this.dialogVisible = false;
				});
		},
	},
};
</script>

<style>
</style>